import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../teamschat-dialog.action';
import { TeamschatDialogState } from '../teamschat-dialog.state';

import { DeleteMessages } from './delete-messages.action';

// TODO revise. maybe do this in the result reducer
export function deleteMessagesReducer(
    state: TeamschatDialogState,
    action: PayloadAction<ActionType, DeleteMessages>,
): TeamschatDialogState {
    const ids = action.payload.messages.map((e) => e.msftChatMessageId);

    const nextMessages = state.messages?.filter(
        (e) => !ids.includes(e.msftChatMessageId),
    );
    const nextConversation = state.conversation?.filter(
        (e) => !ids.includes(e.msftChatMessageId),
    );

    return {
        ...state,
        messages: nextMessages,
        conversation: nextConversation,
    };
}
